import { Component,ViewChild, OnInit,Output, Input,HostListener,EventEmitter,ElementRef } from '@angular/core';
import { ListService } from '../../../services/list.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Global, BaoCao } from '../../../shared/global';
import { Repository } from '../../../services/repository'
import { NgSelectComponent } from '@ng-select/ng-select';
import { LocalDataSource } from 'ng2-smart-table';
import { NumberViewComponent } from '../../../shared/components/public/numberview.component';
import { DateViewComponent } from '../../../shared/components/public/dateview.component';
import { FileRestrictions, SelectEvent, ClearEvent, RemoveEvent, FileInfo } from '@progress/kendo-angular-upload';
import { HttpClient, HttpHeaders, HttpErrorResponse, HttpResponse, HttpEventType, HttpRequest } from '@angular/common/http';
import { BsModalComponent, BsModalBodyComponent, BsModalService } from 'ng2-bs3-modal';
import { DialogComponent, ButtonPropsModel } from '@syncfusion/ej2-angular-popups';
import 'jquery'
import 'bootstrap'

import { DaoTaos_HocVien } from '../../../routes/menu'


const swal = require('sweetalert');


@Component({
    selector: 'app-daotao-dangkyhocedit',
  templateUrl: './dangkyhocedit.component.html',
    //templateUrl: 'ClientApp/routes/DanhMuc/data/data.component.html',
  styleUrls: ['./dangkyhocedit.component.scss'],
    providers: [ListService, Repository]
})


export class dangkyhoceditComponent implements OnInit {

  @ViewChild('ejskhoahoc') public ejskhoahoc: DialogComponent;


  viewSize_height_01: number = 220;
  viewSize_height_02: number = window.innerHeight - 220;

  tong_tien: number = 0;
  tong_giaphi: number = 0;
  tong_giamgia: number = 0;
  tong_thucthu: number = 0;
  tong_sobuoi: number = 0;
  
  @ViewChild('mdGiaoTrinh') mdGiaoTrinh: BsModalComponent;
  @ViewChild('giaotrinhedit') giaotrinhedit: any;
  @ViewChild('mdDangKyGoiHoc') mdDangKyGoiHoc: BsModalComponent;
  @ViewChild('dangkygoihocedit') dangkygoihocedit: any;
  @ViewChild('mdDongHoc') mdDongHoc: BsModalComponent;
  @ViewChild('donghocedit') donghocedit: any;
  @ViewChild('mdDatLich') mdDatLich: BsModalComponent;
  @ViewChild('datlichedit') datlichedit: any;
  @ViewChild('modaltuychinhmaubc') modaltuychinhmaubc: BsModalComponent;
  @ViewChild('dtsuamaubaocao') dtsuamaubaocao: any;
  

  doituongkethua: any;
  doanhnghiepid: string = null;
  @Output() savect: EventEmitter<any> = new EventEmitter();
  datas: any;
  data: any;
  public dulieu: any = { dataGrid: null, dataGridTimKiem: null, datatieude: null, sobanghi: null };
  indLoading: boolean = false;
  dataFrm: FormGroup;
  modalTitle: string;
  modalBtnTitle: string;
  Id: string;
  NgayHienTai: Date = new Date();
  inputDonVi: any;
  public DonViDropId: any = { Id: null, Ten: null };
  public TaiKhoanDropId: any = { Id: null, Ten: null };
  TaiKhoanId: any;
  selecteddonvis: any;
  selectedchuongs: any;
  selectedkhoans: any;
  Ma_Tai_Khoan: any;
  dropdownList_DonVi = [];
  inputTaiKhoan: any;
  dropdownList_TaiKhoan = [];
  selectedItems = [];
  dropdownSettings = {};
  khoangthoigian: number = 0;
  tabselected: number = 1;
  inputthangs: any = [
    { text: "Hôm nay", value: 0 },
    { text: "Tháng 1", value: 1 },
    { text: "Tháng 2", value: 2 },
    { text: "Tháng 3", value: 3 },
    { text: "Tháng 4", value: 4 },
    { text: "Tháng 5", value: 5 },
    { text: "Tháng 6", value: 6 },
    { text: "Tháng 7", value: 7 },
    { text: "Tháng 8", value: 8 },
    { text: "Tháng 9", value: 9 },
    { text: "Tháng 10", value: 10 },
    { text: "Tháng 11", value: 11 },
    { text: "Tháng 12", value: 12 },
    { text: "Quý I", value: 13 },
    { text: "Quý II", value: 14 },
    { text: "Quý III", value: 15 },
    { text: "Quý IV", value: 16 },
    { text: "Tuần này", value: 17 },
    { text: "Tháng này", value: 18 },
    { text: "Năm nay", value: 19 },
    { text: "Đầu năm đến nay", value: 20 },
    { text: "Năm trước", value: 21 },

  ];

  public thangs: Array<{ text: string, value: number }> = [
    { text: "1", value: 1 },
    { text: "2", value: 2 },
    { text: "3", value: 3 },
    { text: "4", value: 4 },
    { text: "5", value: 5 },
    { text: "6", value: 6 },
    { text: "7", value: 7 },
    { text: "8", value: 8 },
    { text: "9", value: 9 },
    { text: "10", value: 10 },
    { text: "11", value: 11 },
    { text: "12", value: 12 }
  ];

  public quys: Array<{ text: string, value: number }> = [
    { text: "1", value: 1 },
    { text: "2", value: 2 },
    { text: "3", value: 3 },
    { text: "4", value: 4 },

  ];

  public nams: Array<{ text: string, value: number }> = [
    { text: (this.NgayHienTai.getFullYear() - 3).toString(), value: (this.NgayHienTai.getFullYear() - 3) },
    { text: (this.NgayHienTai.getFullYear() - 2).toString(), value: (this.NgayHienTai.getFullYear() - 2) },
    { text: (this.NgayHienTai.getFullYear() - 1).toString(), value: (this.NgayHienTai.getFullYear() - 1) },
    { text: this.NgayHienTai.getFullYear().toString(), value: this.NgayHienTai.getFullYear() },
    { text: (this.NgayHienTai.getFullYear() + 1).toString(), value: (this.NgayHienTai.getFullYear() + 1) },
    { text: (this.NgayHienTai.getFullYear() + 2).toString(), value: (this.NgayHienTai.getFullYear() + 2) },
    { text: (this.NgayHienTai.getFullYear() + 3).toString(), value: (this.NgayHienTai.getFullYear() + 3) },

  ];

  public chons: Array<{ text: string, value: number }> = [
    { text: "Theo ngày", value: 1 },
    { text: "Theo tháng", value: 2 },
    { text: "Theo quý", value: 3 },
    { text: "Theo năm", value: 4 },

  ];
  chongioitinhs: any = [{ Id: 0, Ma_Doi_Tuong: "0", Ten_Doi_Tuong: "Nữ" }
    , { Id: 1, Ma_Doi_Tuong: "1", Ten_Doi_Tuong: "Nam" }];
  TatCa: boolean = false;
  public totalItems: number = 0;
  public currentPage: number = 1;
  public maxSize: number = 5;
  public TimKiem: string;
  public StartPage: number = 1;
  public EndPage: number = 20;
  public pageSize: number = 20;
  public pages: any;
  public totalPages: number;
  public TimKiems: any = {
    Don_Vi_Id: null
    , NhanSuId: null
    , UserName: null
    , Nam: null
    , TuNgay: null
    , DenNgay: null
    , Phan_He_Id: null
    , TimKiem: null
    , Loai: null
    , startPage: null
    , endPage: null
    , Ngay: null
    , NgayS: null
    , Ma: null
    , Ten: null
    , Cha: null
    , GhiChu: null
    , NhomDoiTuong: null
    , SapXep: null
    , Modified: null
    , ModifiedS: null
    , ModifiedBy: null
    ,BaoCaoId: null
  };
  public ngaytimkiem: Date = new Date();
  TichTatCa() {
    this.datas.forEach((item: any) => {
      item.Tich = !this.TatCa;
    });
  }
  onKeydownEvent(event: KeyboardEvent): void {
    if (event.keyCode === 13) {
      this.search();
    }
  }

  public TuNgay: Date = new Date();
  public DenNgay: Date = new Date();
  public TuNgay1: Date = new Date();
  public DenNgay1: Date = new Date();
  public tTuNgay: string;
  public tDenNgay: string;

 
 
  idFocus: string = '00000000-0000-0000-0000-000000000000';

  public ngxCurrencyOptions = {
    prefix: '',
    thousands: ',',
    decimal: '.',
    precision: 0,
    allowNegative: false
  };
  public ngxAmOptions = {
    prefix: '',
    thousands: ',',
    decimal: '.',
    precision: 0,
    allowNegative: true
  };

  public currentUser;
  donviid: string = null;
  namketoan: number;
  username: string = null;
  phanheid: any;
  lopid: string;
  nhansuid: string;
  //-----------------cac hàm khởi tạo dữ liệu ban đầu
  constructor(private fb: FormBuilder, private _dataService: ListService, public repo: Repository) {



  }

  // @HostListener('document:keydown', ['$event'])
  public innerHeight: any
  quyen_them: boolean = false;
  hovaten: string;
  loadDataInit(id: string, pheid: string, hovaten: string) {
    this.hovaten = hovaten;
    this.tong_tien = 0;
    this.datas = [];
    this.data2s = [];
    this.lopid = id;
    this.nhansuid = id;
    this.TimKiems.BaoCaoId = id;
    this.ngaytimkiem = null;
    this.StartPage = 1;
    this.EndPage = 20;
    this.ngaytimkiem = null;
    this.innerHeight = window.innerHeight - 250;
    this.phanheid = pheid;
    this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
    if (this.currentUser != null) {
      this.donviid = this.currentUser.id_don_vi;
      this.namketoan = this.currentUser.nam_ke_toan;
      this.username = this.currentUser.user_name;
      var giatri = this.currentUser.ds_quyen.filter(name => name.Id === this.phanheid.toLowerCase());
      if (giatri != null && giatri.length > 0) {
        if (giatri[0].Them == true)
          this.quyen_them = true;
        else
          this.quyen_them = false;
       
      }
     
      this.doanhnghiepid = this.currentUser.id_doanh_nghiep;
    }
    this.search();
        
    
  }

  


 

  
  pageChanged(event: any): void {
    // alert(event.page);
    //console.log('a');
    //console.log(event);
    this.currentPage = event.page;
    this.Loaddatas();
  }
  setPage(page: number): void {
    if (page < 1 || page > this.totalPages) {
      return;
    }

    this.currentPage = page;
    this.Loaddatas();
  }
  public onBlur(): void {
    this.Loaddatas();
  }
  search() {
    this.currentPage = 1;
    this.pageSize = 50;
    this.Loaddatas();
  }
  search1() {
    this.Loaddatas();
  }
  Loaddatas(): void {
    
    this.datas = [];
    this.StartPage = (this.currentPage - 1) * this.pageSize + 1;
    this.EndPage = this.currentPage * this.pageSize;
    this.totalItems = 0;
    this.TimKiems.Don_Vi_Id = this.donviid;
    this.TimKiems.UserName = this.currentUser.user_name;
    this.TimKiems.LopId = this.lopid;
    this.TimKiems.NhanSuId = this.lopid;
    this.TimKiems.Nam = this.currentUser.nam_ke_toan;
    this.TimKiems.startPage = this.StartPage;
    this.TimKiems.endPage = this.EndPage;
    if (this.ngaytimkiem != null) {
      this.TimKiems.ModifiedS = this.ngaytimkiem.getFullYear() + '-' + (this.ngaytimkiem.getMonth() + 1) + '-' + this.ngaytimkiem.getDate();
    }
    else
      this.TimKiems.ModifiedS = null;


    let data = {
      Id: null,
      Type: null,
      Data: JSON.stringify(this.TimKiems)
    };
    $('#loading').show();
    this.repo.postRequest("api/dangkygoihoc/get_dangky_listviewpage_dangky/", this.TimKiems)
      .subscribe(response => {
        $('#loading').hide();
        this.totalPages = 0;
        this.totalItems = 0;
        if (response.length > 0) {

          this.tId = response[0].Id;
          this.TimKiem2s.DangKyId = response[0].Id;
          this.TimKiem3s.DangKyId = response[0].Id;
          this.search2();
          this.search3();

          var item = response[0];
          this.totalItems = item["totalRows"];
          this.totalPages = Math.ceil(this.totalItems / this.pageSize);

          let start, end;

          if (this.totalPages <= 5) {
            start = 1;
            end = this.totalPages;
          } else {
            if (this.currentPage <= 3) {
              start = 1;
              end = 5;
            } else if (this.currentPage + 1 >= this.totalPages) {
              start = this.totalPages - 4;
              end = this.totalPages;
            } else {
              start = this.currentPage - 2;
              end = this.currentPage + 2;
            }
          }

          let resultArray: Array<any> = [];
          for (var i = start; i <= end; i++) {
            resultArray.push({ Id: i, Ten: null });
          }
          this.pages = resultArray;
        }
        this.datas = response;

        this.tong_giaphi = 0;
        this.tong_giamgia = 0;
        this.tong_thucthu = 0;
        this.tong_sobuoi = 0;
        // tính tổng
        if (this.datas != null)
        this.datas.forEach(
          (item) => {
            this.tong_giaphi = this.tong_giaphi + (item.GiaPhi === null ? 0 : item.GiaPhi);
            this.tong_giamgia = this.tong_giamgia + (item.DuocGiam === null ? 0 : item.DuocGiam);
            this.tong_thucthu = this.tong_thucthu + (item.ThucThu === null ? 0 : item.ThucThu);
            this.tong_sobuoi = this.tong_sobuoi + (item.SoBuoi === null ? 0 : item.SoBuoi);
          }
        );

        (window as any).timer4(0, 1500);

      });



  }

  tId: any;
  selectedRow: any;
  selected(row: any) {
    this.tId = row.Id;
    this.selectedRow = row;
    this.TimKiem2s.DangKyId = this.tId;
    this.TimKiem3s.DangKyId = this.tId;
    this.search2();
    this.search3();
  }

  tId2: any;
  selectedRow2: any;
  selected2(row: any) {
    this.tId2 = row.Id;
    this.selectedRow2 = row;
  }
  tId3: any;
  selectedRow3: any;
  selected3(row: any) {
    this.tId3 = row.Id;
    this.selectedRow3 = row;
  }


  data2s: any;
  public totalItem2s: number = 0;
  public currentPage2: number = 1;
  public maxSize2: number = 5;
  public TimKiem2: string;
  public StartPage2: number = 1;
  public EndPage2: number = 20;
  public pageSize2: number = 20;
  public page2s: any;
  public totalPage2s: number;
  public TimKiem2s: any = {
    Don_Vi_Id: null
    , NhanSuId: null
    , DangKyId: null
    , UserName: null
    , Nam: null
    , TuNgay: null
    , DenNgay: null
    , Phan_He_Id: null
    , TimKiem: null
    , Loai: null
    , startPage: null
    , endPage: null
    , Ngay: null
    , NgayS: null
    , Ma: null
    , Ten: null
    , Cha: null
    , GhiChu: null
    , NhomDoiTuong: null
    , SapXep: null
    , Modified: null
    , ModifiedS: null
    , ModifiedBy: null
    , BaoCaoId: null
  };
  onKeydownEvent2(event: KeyboardEvent): void {
    if (event.keyCode === 13) {
      this.search2();
    }
  }

  pageChanged2(event: any): void {
    // alert(event.page);
    //console.log('a');
    //console.log(event);
    this.currentPage2 = event.page;
    this.Loaddata2s();
  }
  setPage2(page: number): void {
    if (page < 1 || page > this.totalPage2s) {
      return;
    }

    this.currentPage2 = page;
    this.Loaddata2s();
  }
  public onBlur2(): void {
    this.Loaddata2s();
  }
  search2() {
    this.currentPage2 = 1;
    this.pageSize2 = 50;
    this.Loaddata2s();
  }
  search21() {
    this.Loaddata2s();
  }
  Loaddata2s(): void {
    this.data2s = [];
    this.StartPage2 = (this.currentPage2 - 1) * this.pageSize2 + 1;
    this.EndPage2 = this.currentPage2 * this.pageSize2;
    this.totalItem2s = 0;
    this.TimKiem2s.Don_Vi_Id = this.donviid;
    this.TimKiem2s.UserName = this.currentUser.user_name;
    this.TimKiem2s.LopId = this.lopid;
    this.TimKiems.NhanSuId = this.lopid;
    this.TimKiems.DangKyId = this.tId;
    this.TimKiem2s.Nam = this.currentUser.nam_ke_toan;
    this.TimKiem2s.startPage = this.StartPage2;
    this.TimKiem2s.endPage = this.EndPage2;
    
    let data = {
      Id: null,
      Type: null,
      Data: JSON.stringify(this.TimKiem2s)
    };
    $('#loading').show();
    this.repo.postRequest("api/dangkygoihoc/get_dangky_donghoc_listviewpage/", this.TimKiem2s)
      .subscribe(response => {
        $('#loading').hide();
        this.totalPage2s = 0;
        this.totalItem2s = 0;
        if (response.length > 0) {

          var item = response[0];
          this.totalItem2s = item["totalRows"];
          this.totalPage2s = Math.ceil(this.totalItem2s / this.pageSize2);

          let start, end;

          if (this.totalPage2s <= 5) {
            start = 1;
            end = this.totalPage2s;
          } else {
            if (this.currentPage2 <= 3) {
              start = 1;
              end = 5;
            } else if (this.currentPage2 + 1 >= this.totalPage2s) {
              start = this.totalPage2s - 4;
              end = this.totalPage2s;
            } else {
              start = this.currentPage2 - 2;
              end = this.currentPage2 + 2;
            }
          }

          let resultArray: Array<any> = [];
          for (var i = start; i <= end; i++) {
            resultArray.push({ Id: i, Ten: null });
          }
          this.page2s = resultArray;
        }
        this.data2s = response;

        this.tong_tien = 0;
        // tính tổng
        if (this.data2s != null)
          this.data2s.forEach(
            (item) => {
              this.tong_tien = this.tong_tien + (item.SoTien === null ? 0 : item.SoTien);
              
            }
          );

        (window as any).timer5(0, 1500);

      });



  }


  data3s: any;
  public totalItem3s: number = 0;
  public currentPage3: number = 1;
  public maxSize3: number = 5;
  public TimKiem3: string;
  public StartPage3: number = 1;
  public EndPage3: number = 20;
  public pageSize3: number = 20;
  public page3s: any;
  public totalPage3s: number;
  public TimKiem3s: any = {
    Don_Vi_Id: null
    , DangKyId: null
    , NhanSuId: null
    , UserName: null
    , Nam: null
    , TuNgay: null
    , DenNgay: null
    , Phan_He_Id: null
    , TimKiem: null
    , Loai: null
    , startPage: null
    , endPage: null
    , Ngay: null
    , NgayS: null
    , Ma: null
    , Ten: null
    , Cha: null
    , GhiChu: null
    , NhomDoiTuong: null
    , SapXep: null
    , Modified: null
    , ModifiedS: null
    , ModifiedBy: null
    , BaoCaoId: null
  };
  onKeydownEvent3(event: KeyboardEvent): void {
    if (event.keyCode === 13) {
      this.search3();
    }
  }

  pageChanged3(event: any): void {
    // alert(event.page);
    //console.log('a');
    //console.log(event);
    this.currentPage3 = event.page;
    this.Loaddata3s();
  }
  setPage3(page: number): void {
    if (page < 1 || page > this.totalPage3s) {
      return;
    }

    this.currentPage3 = page;
    this.Loaddata3s();
  }
  public onBlur3(): void {
    this.Loaddata3s();
  }
  search3() {
    this.currentPage3 = 1;
    this.pageSize3 = 50;
    this.Loaddata3s();
  }
  search31() {
    this.Loaddata3s();
  }
  Loaddata3s(): void {
    this.data3s = [];
    this.StartPage3 = (this.currentPage3 - 1) * this.pageSize3 + 1;
    this.EndPage3 = this.currentPage3 * this.pageSize3;
    this.totalItem3s = 0;
    this.TimKiem3s.Don_Vi_Id = this.donviid;
    this.TimKiem3s.UserName = this.currentUser.user_name;
    this.TimKiem3s.LopId = this.lopid;
    this.TimKiems.NhanSuId = this.lopid;
    this.TimKiems.DangKyId = this.tId;
    this.TimKiem3s.Nam = this.currentUser.nam_ke_toan;
    this.TimKiem3s.startPage = this.StartPage3;
    this.TimKiem3s.endPage = this.EndPage3;

    let data = {
      Id: null,
      Type: null,
      Data: JSON.stringify(this.TimKiem3s)
    };
    $('#loading').show();
    this.repo.postRequest("api/dangkygoihoc/get_dangky_datlich_listviewpage/", this.TimKiem3s)
      .subscribe(response => {
        $('#loading').hide();
        this.totalPage3s = 0;
        this.totalItem3s = 0;
        if (response.length > 0) {

          var item = response[0];
          this.totalItem3s = item["totalRows"];
          this.totalPage3s = Math.ceil(this.totalItem3s / this.pageSize3);

          let start, end;

          if (this.totalPage3s <= 5) {
            start = 1;
            end = this.totalPage3s;
          } else {
            if (this.currentPage3 <= 3) {
              start = 1;
              end = 5;
            } else if (this.currentPage3 + 1 >= this.totalPage3s) {
              start = this.totalPage3s - 4;
              end = this.totalPage3s;
            } else {
              start = this.currentPage3 - 2;
              end = this.currentPage3 + 2;
            }
          }

          let resultArray: Array<any> = [];
          for (var i = start; i <= end; i++) {
            resultArray.push({ Id: i, Ten: null });
          }
          this.page3s = resultArray;
        }
        this.data3s = response;

       // (window as any).timer6(0, 1500);

      });



  }


  public ngonngu(text: string) {
    return this.repo.NgonNgu(text);
  }
  ngOnInit(): void {
    var crru = JSON.parse(localStorage.getItem('currentUser'));
    if (crru != null) {
      this.donviid = crru.id_don_vi;
      this.namketoan = crru.nam_ke_toan;
      this.username = crru.user_name;
    }
    this.LoadCategory();
  }

  LoadCategory(): void {

  }
  //----------event xử lý di chuyển Enter--------------------------------------
  tongtien: number = 0;
  maxcot: number = 13;

  onDoiTuongChange($event) {

    //if (typeof $event === "undefined") {
    //  this.doituongSelect.Ho_Ten = null;
    //}
    //else {
    //  this.doituongSelect.Ho_Ten = $event.Ten_Doi_Tuong;

    //  this.doituongSelect.ChiTiets.forEach(
    //    (item) => {
    //      if (item.Doi_Tuong_Id2 === null)
    //        item.Doi_Tuong_Id2 = $event.Id;
    //    }
    //  );

    //  this.repo.getRequest("api/baselayout/ThongTinDiaChi/" + $event.Id)
    //    .subscribe(response => {
    //      //console.log(response);
    //      this.doituongSelect.Dia_Chi = response.Dia_Chi;

    //    });
    //}
  }

  comboSearchFn(term: string, item: any) {
    term = term.toLowerCase();
    return item.Ma_Doi_Tuong.toLowerCase().indexOf(term) > -1 || item.Ten_Doi_Tuong.toLowerCase().indexOf(term) > -1;
  }
  comboSearchFn_DV(term: string, item: any) {
    term = term.toLowerCase();
    return item.Ma_Don_Vi.toLowerCase().indexOf(term) > -1 || item.Ten_Don_Vi.toLowerCase().indexOf(term) > -1;
  }
  rowSelected: any = null;
  comboSeleted: NgSelectComponent;

  public save_chondoituong2(item: any) {
    let tdoituong = [];
    tdoituong.push(item);
    this.savect.emit(tdoituong);
  }
  public save_chondoituong() {  
    let tdoituong = [];
    this.savect.emit(tdoituong);

    //this.datas.forEach(
    //  (item) => {
    //    if (item.Tich === true)
    //      tdoituong.push(item);
    //  }
    //);
    //if (tdoituong != null && tdoituong.length > 0)
    //  this.savect.emit(tdoituong);
    //else
    //  this.savect.emit(null);

  }
  closeModal_chondoituong() {
    let tdoituong =null;
    this.savect.emit(tdoituong);
  }
  nhomdoituongid: string;
  onLoaiNguoiNop(row: any) {
    this.nhomdoituongid = row.Id;
    //console.log(loai);
  }

  mBackdrop: any;
  haveBackdrop() {
    if ($('.modal-backdrop').length > 0) {
      $('.modal-backdrop').css("z-index", -1)
      clearTimeout(this.mBackdrop);
      return true;
    }

    return false;
  }

  adddata() {
    
    this.nhomdoituongid = null;
    this.modalTitle = "Thêm thông tin đăng ký gói học";
    this.dangkygoihocedit.loadDataInit(this.phanheid, null, this.donviid, null, this.nhansuid,0);
    this.mBackdrop = setTimeout(() => {
      this.haveBackdrop();
    }, 500);
    this.mdDangKyGoiHoc.open();

  }
  editdata_dangky() {
    if (this.selectedRow != null)
      this.editdata(this.selectedRow);
    else
      swal('Cảnh báo!', 'Chưa chọn đăng ký gói học để sửa!.', 'warning');
  }
  deleterow_dangky() {
    if (this.selectedRow != null)
      this.deleterow(this.selectedRow);
    else
      swal('Cảnh báo!', 'Chưa chọn đăng ký gói học để xóa!.', 'error');
  }


  editdata(row: any) {
    
    this.modalTitle = "cập nhập thông tin đăng ký gói học";
    this.modalBtnTitle = "Cập nhật";
    this.dangkygoihocedit.loadDataInit(this.phanheid, row.Id, this.donviid, row, this.nhansuid);
    this.mdDangKyGoiHoc.open();
  }


  saveModalDangKy(doituong: any) {
    this.mdDangKyGoiHoc.close();
    this.search();
  }

  adddata_donghoc() {

    if (this.tId != null) {
      this.nhomdoituongid = null;
      this.modalTitle = "Thêm thông tin đóng học";

      if (this.selectedRow2 != null && this.selectedRow2.MaLop != null)
        this.hovaten = this.selectedRow2.HoVaTen + " " + this.selectedRow2.MaLop;

      this.donghocedit.loadDataInit(this.phanheid, null, this.donviid, null, this.tId, null, this.hovaten);
      this.mBackdrop = setTimeout(() => {
        this.haveBackdrop();
      }, 500);
      this.mdDongHoc.open();
    }
    else
      swal('Cảnh báo!', 'Chưa chọn đăng ký gói học để thêm đóng học!.', 'warning');

  }
  editdata_donghoc() {
    if (this.selectedRow2 != null)
      this.editdata2(this.selectedRow2);
    else
      swal('Cảnh báo!', 'Chưa chọn thông tin đóng học để sửa!.', 'warning');
  }
  deleterow_donghoc() {
    if (this.selectedRow2 != null)
      this.deleterow_DH(this.selectedRow2);
    else
      swal('Cảnh báo!', 'Chưa chọn thông tin đóng học để xóa!.', 'error');
  }


  editdata2(row: any) {

    this.modalTitle = "cập nhập thông tin đóng học";
    this.modalBtnTitle = "Cập nhật";

    if (this.selectedRow2 != null && this.selectedRow2.MaLop!=null)
      this.hovaten = this.selectedRow2.HoVaTen + " " + this.selectedRow2.MaLop;

    this.donghocedit.loadDataInit(this.phanheid, row.Id, this.donviid, row, this.tId, null, this.hovaten);
    this.mdDongHoc.open();
  }


  saveModalDongHoc(doituong: any) {
    this.mdDongHoc.close();
    this.search2();
  }

 
  //editdata3(row: any) {

  //  this.modalTitle = "cập nhập thông tin lịch học";
  //  this.modalBtnTitle = "Cập nhật";
  //  this.giaotrinhedit.loadDataInit(this.phanheid, row.Id, this.donviid, row, this.lopid);
  //  this.mdGiaoTrinh.open();
  //}

  saveModalKhacHang(doituong: any) {
    this.mdGiaoTrinh.close();
    this.search();
  }

 
 

  saveModal(doituong: any) {
    this.mdGiaoTrinh.close();
    if (doituong != null)
    this.search();
  }
  deleterow(row: any) {
    swal({
      title: 'Bạn muốn xóa đăng ký này phải không?',
      text: '',
      icon: "warning",
      buttons: {
        cancel: {
          text: 'Hủy bỏ',
          value: false,
          visible: true,
        },
        confirm: {
          text: 'Đồng ý',
          value: true,
          visible: true,
          className: "bg-danger",
          closeModal: true
        }
      }
    })
      .then(willDelete => {
        if (willDelete) {
          this.repo.postRequest('api/dangkygoihoc/delete_dangky/', { IdGuid: row.Id, PhanHeId: DaoTaos_HocVien.id, UserName: this.currentUser.user_name }).subscribe(
            data => {
              if (data == "OK") //Success
              {
                swal('Deleted!', 'Dữ liệu đã được xóa!.', 'success');

                this.Loaddatas();
              }
              else {
                // this.msg = data;
                swal('Cảnh báo!', data, 'warning');
              }


            },
            error => {
              //this.msg = error;
            }
          );
        }
      });

  }

  deleterow_DH(row: any) {

    swal({
      title: 'Bạn muốn xóa thông tin đóng tiền này phải không?',
      text: '',
      icon: "warning",
      buttons: {
        cancel: {
          text: 'Hủy bỏ',
          value: false,
          visible: true,
        },
        confirm: {
          text: 'Đồng ý',
          value: true,
          visible: true,
          className: "bg-danger",
          closeModal: true
        }
      }
    })
      .then(willDelete => {
        if (willDelete) {
          this.repo.postRequest('api/dangkygoihoc/delete_donghoc/', { IdGuid: row.Id, PhanHeId: DaoTaos_HocVien.id, UserName: this.currentUser.user_name }).subscribe(
            data => {
              if (data == "OK") //Success
              {
                swal('Deleted!', 'Dữ liệu đã được xóa!.', 'success');

                this.Loaddata2s();
              }
              else {
                // this.msg = data;
                swal('Cảnh báo!', data, 'warning');
              }


            },
            error => {
              //this.msg = error;
            }
          );
        }
      });


  }



  adddata_datlich() {

    if (this.tId != null) {
      this.nhomdoituongid = null;
      this.modalTitle = "Thêm thông tin đặt lịch thu học phí";
      this.datlichedit.loadDataInit(this.phanheid, null, this.donviid, null, this.tId);
      this.mBackdrop = setTimeout(() => {
        this.haveBackdrop();
      }, 500);
      this.mdDatLich.open();
    }
    else
      swal('Cảnh báo!', 'Chưa chọn đăng ký gói học để thêm đặt lịch thu học phí!.', 'warning');

  }
  editdata_datlich() {
    if (this.selectedRow3 != null)
      this.editdata3(this.selectedRow3);
    else
      swal('Cảnh báo!', 'Chưa chọn thông tin đặt lịch thu học phí để sửa!.', 'warning');
  }
  deleterow_datlich() {
    if (this.selectedRow3 != null)
      this.deleterow_DH(this.selectedRow3);
    else
      swal('Cảnh báo!', 'Chưa chọn thông tin đặt lịch thu học phí để xóa!.', 'error');
  }


  editdata3(row: any) {

    this.modalTitle = "cập nhập thông tin đặt lịch thu học phí";
    this.modalBtnTitle = "Cập nhật";
    this.datlichedit.loadDataInit(this.phanheid, row.Id, this.donviid, row, this.tId);
    this.mdDatLich.open();
  }


  saveModalDatLich(doituong: any) {
    this.mdDatLich.close();
    this.search3();
  }
  deleterow_DatLich(row: any) {

    swal({
      title: 'Bạn muốn xóa thông tin đóng tiền này phải không?',
      text: '',
      icon: "warning",
      buttons: {
        cancel: {
          text: 'Hủy bỏ',
          value: false,
          visible: true,
        },
        confirm: {
          text: 'Đồng ý',
          value: true,
          visible: true,
          className: "bg-danger",
          closeModal: true
        }
      }
    })
      .then(willDelete => {
        if (willDelete) {
          this.repo.postRequest('api/dangkygoihoc/delete_datlich/', { IdGuid: row.Id, PhanHeId: DaoTaos_HocVien.id, UserName: this.currentUser.user_name }).subscribe(
            data => {
              if (data == "OK") //Success
              {
                swal('Deleted!', 'Dữ liệu đã được xóa!.', 'success');

                this.Loaddata3s();
              }
              else {
                // this.msg = data;
                swal('Cảnh báo!', data, 'warning');
              }


            },
            error => {
              //this.msg = error;
            }
          );
        }
      });


  }


  public tuychinhmaubaocao() {
    this.dtsuamaubaocao.loadDataInit("4A1EF676-B194-41E4-8506-D608EF9F8F24");
    this.modaltuychinhmaubc.open();
  }
  public tuychinhmaubaocao2() {
    this.dtsuamaubaocao.loadDataInit("D7097D40-37F5-4300-AB66-C057613F831C");
    this.modaltuychinhmaubc.open();
  }
  public export(kieuin) {
    if (this.selectedRow2 == null)
     swal('Cảnh báo!', 'Chưa chọn thông tin đóng học để in hóa đơn!.', 'error');
    let filename = "";

    filename = this.selectedRow2.HoVaTen + " " + this.selectedRow2.MaLop;

    $('#loading').show();
    let data = {
      Id: "4A1EF676-B194-41E4-8506-D608EF9F8F24",
      Type: kieuin,
      Data: JSON.stringify({ Id: this.selectedRow2.Id, UserName: this.username, DonViId: this.currentUser.id_don_vi })
    };
    if (kieuin === 'xlsx') {
      this.repo.postPdf(Global.BASE_BaoCao_SAVE, data)
        .subscribe(response => {
          if (response == "L") {
            this.repo.postRequest(Global.BASE_BaoCao_SAVE, data).subscribe(
              data => {
                $('#loading').hide();
              },
              error => {
                
              }
            );
          }
          else {
            $('#loading').hide();
            var file = new Blob([response.body], { type: 'vnd.ms-excel' });
            var fileURL = URL.createObjectURL(file);
            var a = document.createElement("a");
            a.href = fileURL;
            let ngay = new Date();
            a.download = "hoa_don.xlsx";
            document.body.appendChild(a);
            a.click();
          }


        });
    }
    if (kieuin === 'pdf') {
      this.repo.postPdf(Global.BASE_BaoCao_SAVE, data)
        .subscribe(response => {
          //console.log("tt");
          //console.log(response);
          if (response == "L") {
            this.repo.postRequest(Global.BASE_BaoCao_SAVE, data).subscribe(
              data => {
                $('#loading').hide();
              },
              error => {
              
              }
            );
          }
          else {
            $('#loading').hide();
            var file = new Blob([response.body], { type: 'application/pdf' });
            var fileURL = URL.createObjectURL(file);
            window.open(fileURL, "EPrescription");
            var a = document.createElement("a");
            a.href = fileURL;
            let ngay = new Date();
            a.download = filename + ".pdf";
            document.body.appendChild(a);
            a.click();
          }

        });
    }



  }

  public export2(kieuin) {
    if (this.selectedRow2 == null)
      swal('Cảnh báo!', 'Chưa chọn thông tin đóng học để in hóa đơn!.', 'error');
    let filename = "";

    filename = this.selectedRow2.HoVaTen + " " + this.selectedRow2.MaLop;

    $('#loading').show();
    let data = {
      Id: "D7097D40-37F5-4300-AB66-C057613F831C",
      Type: kieuin,
      Data: JSON.stringify({ Id: this.selectedRow2.Id, UserName: this.username, DonViId: this.currentUser.id_don_vi })
    };
    if (kieuin === 'xlsx') {
      this.repo.postPdf(Global.BASE_BaoCao_SAVE, data)
        .subscribe(response => {
          if (response == "L") {
            this.repo.postRequest(Global.BASE_BaoCao_SAVE, data).subscribe(
              data => {
                $('#loading').hide();
              },
              error => {

              }
            );
          }
          else {
            $('#loading').hide();
            var file = new Blob([response.body], { type: 'vnd.ms-excel' });
            var fileURL = URL.createObjectURL(file);
            var a = document.createElement("a");
            a.href = fileURL;
            let ngay = new Date();
            a.download = "hoa_don.xlsx";
            document.body.appendChild(a);
            a.click();
          }


        });
    }
    if (kieuin === 'pdf') {
      this.repo.postPdf(Global.BASE_BaoCao_SAVE, data)
        .subscribe(response => {
          //console.log("tt");
          //console.log(response);
          if (response == "L") {
            this.repo.postRequest(Global.BASE_BaoCao_SAVE, data).subscribe(
              data => {
                $('#loading').hide();
              },
              error => {

              }
            );
          }
          else {
            $('#loading').hide();
            var file = new Blob([response.body], { type: 'application/pdf' });
            var fileURL = URL.createObjectURL(file);
            window.open(fileURL, "EPrescription");
            //var a = document.createElement("a");
            //a.href = fileURL;
            //let ngay = new Date();
            //a.download = filename + ".pdf";
            //document.body.appendChild(a);
            //a.click();
          }

        });
    }



  }

  

}
